module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/La-Cicer-e4cb7e4cd5c0c630175f4076aebb06ef.jpg";